var _defs, _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#4c4c4c;}.cls-2{fill:#9bc5cc;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "admin") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 100,
    cy: 100,
    r: 100
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M150,152.76a31.38,31.38,0,1,0-31.38-31.38A31.37,31.37,0,0,0,150,152.76Z",
    transform: "translate(-50 -50)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M185.23,154a9.9,9.9,0,0,0-11.91-.36,40.6,40.6,0,0,1-46.51.1,10.25,10.25,0,0,0-12.46.61c-11.48,9.64-19.07,26.26-19.07,45.16h0c0,5.82,3.68,10.54,8.22,10.54h93c4.54,0,8.22-4.72,8.22-10.54h0C204.72,180.33,197,163.53,185.23,154Z",
    transform: "translate(-50 -50)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/admin.f5788553ffdfe4ebd81e3a45fa870227.svg";
export { ForwardRef as ReactComponent };